import { HistoryState } from '../../../models';
import { HISTORY_MUTATIONS_KEYS } from '../history.const';
import { HistoryMutation } from '../history.interfaces';

export class SetSessionQueryHistoryMutation implements HistoryMutation {
  mutations = {
    [HISTORY_MUTATIONS_KEYS.setSessionQueryHistory]: (localState: HistoryState, queryHistory: string[]) => {
      localState.sessionQueryHistory = queryHistory;
    }
  };
}
